<template>
  <div>
    <div class="text-gray-500 text-xs font-normal">{{ title }}</div>
    <div class="text-gray-800 text-sm">
      <slot>{{ value }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: [String, Number],
  },
};
</script>
